import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Box,
  Alert,
  Snackbar,
   Dialog,           // ✅ أضف هذا
  DialogTitle,      // ✅
  DialogContent,    // ✅
  DialogActions,    // ✅
  TextField,        // ✅
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { db } from "./firebase";
import { collection, getDocs, getDoc, doc, updateDoc } from "firebase/firestore";
import Modal from "./Modal";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "./firebase";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom"; // ✅ جديد
import { apiFetch } from "./utils/apiClient";
import UploadPreview from "./components/UploadPreview";
import { showBuiltIn } from "./utils/accountBuiltIns";

const API_BASE =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000/api"
    : "https://artikaorder-backend.onrender.com/api";

const DRAWING_CHECKLIST_ITEMS = [
  { key: "percentage", label: "تأكدت من نسبة الرسم" },
  { key: "matchPrint", label: "تأكدت من مطابقة اللوحة المرسومة مع المطبوعة" },
  { key: "notes", label: "تأكدت من ملاحظات الرسم" },
  { key: "colors", label: "تأكدت من مطابقة الألوان" },
];

const HalimaDashboard = () => {
  const [orders, setOrders] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  // ✅ state لتعطيل الأزرار محلياً أول ما تنضغط
const [disabledButtons, setDisabledButtons] = useState({});
const [completeOpen, setCompleteOpen] = useState(false);
const [drawingChecklist, setDrawingChecklist] = useState({
  percentage: false,
  matchPrint: false,
  notes: false,
  colors: false,
});
const [driveLink, setDriveLink] = useState("");
const [selectedOrderId, setSelectedOrderId] = useState(null);
const [selectedLinkedOrderId, setSelectedLinkedOrderId] = useState(null);
const [snackbarMsg, setSnackbarMsg] = useState("✅ تم تحديث الطلب بنجاح!");
const [loading, setLoading] = useState(false); // ✅ حالة التحميل
const [uploading, setUploading] = useState(false);
  const navigate = useNavigate(); // ✅ نحتاجه للانتقال إلى صفحة المقارنة
  const username = localStorage.getItem("username");

const USER_TO_EMPLOYEE = {
  "Baneen@123": "بنين",
  "sara@123": "سارة",
  "jumana@123": "جومانا",
  "designer@123": "المصمم",
  "halima@123": "الرسام",
  "maryam@123": "مريم",
  "karina@123": "تيهان",
  "mohamed@123": "الرسام",
  "farah@123": "فرح",
  "maysa@123": "مياسة",
};

const myEmployeeName = USER_TO_EMPLOYEE[username] || "الرسام";

const [selectedRequestKind, setSelectedRequestKind] = useState("new");

const [selectedVideo, setSelectedVideo] = useState(null);

  const handleImageClick = (url) => {
    setSelectedImage(url);
    setIsModalOpen(true);
  };

  const normalizeArr = (value) => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  };

  // ✅ صور المقارنة (اللوحة المطبوعة / المرسومة) لازم تكون مرفوعة قبل رفع فيديو الرسم
  const ensureComparisonBoardsUploaded = async (linkedOrderId) => {
    try {
      const orderSnap = await getDoc(doc(db, "orders", linkedOrderId));
      const orderData = orderSnap.exists() ? orderSnap.data() : {};
      const compareBoards = orderData.compareBoards || {};

      const halimaPrintImages = normalizeArr(compareBoards.halimaPrintedBoard);
      if (halimaPrintImages.length === 0) {
        alert(
          "⚠️ يجب رفع صور المقارنة (اللوحة المطبوعة) من صفحة مقارنة اللوحات أولاً قبل رفع فيديو الرسم."
        );
        return false;
      }

      if (orderData.withDrawing) {
        const drawingImages = normalizeArr(compareBoards.drawingBoard);
        if (drawingImages.length === 0) {
          alert(
            "⚠️ يجب رفع صور المقارنة (اللوحة المرسومة) من صفحة مقارنة اللوحات أولاً قبل رفع فيديو الرسم."
          );
          return false;
        }
      }

      return true;
    } catch (err) {
      console.error("❌ خطأ في التحقق من صور المقارنة:", err);
      alert("❌ حدث خطأ أثناء التحقق من صور المقارنة");
      return false;
    }
  };

const handleStatusUpdate = async (order, action) => {
  const halimaId = order.id;
  const orderId = order.linkedOrderId; // هو id مال orders
    
  // ✅ عطّل الزر مباشرة أول ما ينضغط
  setDisabledButtons((prev) => ({
    ...prev,
    [halimaId + "_" + action]: true,
  }));

    try {
      if (!orderId) {
        console.error("❌ orderId مفقود!");
        alert("❌ الطلب لا يحتوي على orderId صالح");
        return;
      }

      // 1. تحديث halimaRequests (التاسك الخاص بحليمة)
      const halimaRef = doc(db, "halimaRequests", halimaId);
      await updateDoc(halimaRef, { status: action });

      // 2. تجهيز الحالة الجديدة
    let newStatus = "";

// ✅ نحدد نوع الطلب (بيع مباشر لو طلب جديد)
// ✅ ما نميز هنا — دائماً نخليها ترجع "رسم مكتمل" حتى يكملها الورشة
if (action === "قيد العمل") newStatus = "عند برهان - رسم حليمة بدأت";
if (action === "مكتمل") newStatus = "عند برهان - رسم حليمة مكتمل";



      // 3. تحديث الطلب الأصلي (orders)
      const statusRes = await apiFetch(`${API_BASE}/orders/${orderId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          status: newStatus,
          by: "حليمة",
        }),
      });

      if (!statusRes.ok) {
        const errData = await statusRes.json().catch(() => ({}));
        throw new Error(errData.error || "حدث خطأ أثناء تحديث حالة الطلب");
      }
// ✅ حدّث الـ state محليًا بدون رفرش
setOrders((prevOrders) =>
  prevOrders.map((o) =>
    o.id === halimaId
      ? { ...o, status: action } // حدّث حالة halimaRequests
      : o
  )
);
      setSnackbarOpen(true);
    } catch (error) {
      console.error("❌ خطأ في تحديث الحالة:", error);
      alert("❌ حدث خطأ أثناء تحديث الحالة");
    }
  };

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "halimaRequests"));
        const allOrders = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
       setOrders(
        allOrders.sort((a, b) => {
          const dateA = a.orderCreatedAt?.seconds || 0;
          const dateB = b.orderCreatedAt?.seconds || 0;
          return dateA - dateB;
        })
      );
    } catch (error) {
      console.error("Error fetching halima data:", error);
    }
  };

  fetchOrders();
}, []);

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      
    {/* ✅ زر طلب إجازة */}
    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
      {showBuiltIn("box:leaveRequest") && (
      <Button
        variant="contained"
        color="primary"
onClick={() => navigate("/leave-request?u=halima@123&returnTo=/halima")}
        sx={{ fontWeight: 800, borderRadius: 2, px: 3 }}
      >
        📝 طلب إجازة
      </Button>
      )}
      {showBuiltIn("box:materialRequest") && (
      <Button
        variant="contained"
        color="secondary"
        onClick={() => navigate("/material-request?u=halima@123&returnTo=/halima")}
        sx={{ fontWeight: 800, borderRadius: 2, px: 3, ml: 1 }}
      >
        🎨 طلب مواد
      </Button>
      )}
    </Box>
   
      <Typography variant="h5" gutterBottom align="center">
        🖌️ واجهة الرسام - الطلبات المرسلة للرسم
      </Typography>

      {orders.length === 0 ? (
        <Alert severity="info" sx={{ mt: 4 }}>
          لا توجد طلبات مرسلة حالياً إلى الرسام.
        </Alert>
      ) : (
       orders
  .filter((order) => order.status !== "مكتمل")   // ✅ استبعد الطلبات المكتملة
  .map((order) => (
    <Accordion key={order.id} sx={{ mb: 2 }}>

            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>
                🧾 {order.customerName} | المحافظة: {order.governorate}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {order.drawingNote && (
                <Paper sx={{ p: 2, mb: 2, backgroundColor: "#f5f5f5" }}>
                  <Typography variant="subtitle2">📝 ملاحظات:</Typography>
                  <Typography>{order.drawingNote}</Typography>
                </Paper>
              )}

              {order.imageUrls?.length > 0 && (
                <>
                  <Typography variant="subtitle2" gutterBottom>
                    🖼️ الصور المرفقة:
                  </Typography>
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    {order.imageUrls.map((url, idx) => (
                      <img
                        onClick={() => handleImageClick(url)}
                        key={idx}
                        src={url}
                        alt={`halima-${idx}`}
                        style={{
                          width: 120,
                          height: 120,
                          objectFit: "cover",
                          borderRadius: 8,
                          border: "1px solid #ccc",
                          cursor: "pointer",
                        }}
                      />
                    ))}
                  </Box>
<Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",   // يغطي كل الشاشة
      p: 2,
    }}
  >
    <img
      src={selectedImage}
      alt="Selected"
      style={{
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",  // يخلي الصورة تبقى بنسبها
        borderRadius: "8px",
      }}
    />
  </Box>
</Modal>

                </>
              )}

              {order.orderCreatedAt && (
                <Typography sx={{ mt: 1, fontWeight: "bold" }}>
                  🗓️ التاريخ:{" "}
                  {new Date(order.orderCreatedAt.seconds * 1000).toLocaleString()}
                </Typography>
              )}
{/* ✅ زر مقارنة اللوحات / رفع الرسم */}
{order.linkedOrderId && (
  <Box sx={{ mt: 2 }}>
    <Button
      variant="contained"
      color="primary"
      onClick={() => navigate(`/compare-boards/${order.linkedOrderId}`)}
    >
      🖼️ مقارنة اللوحات / رفع الرسم
    </Button>
  </Box>
)}

  <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
  {/* زر قيد العمل */}
  {!(order.status === "قيد العمل" || order.status === "مكتمل") && (
    <button
      style={{
        padding: "8px 16px",
        backgroundColor: "#fbc02d",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
      }}
      onClick={() =>
handleStatusUpdate(order, "قيد العمل")
      }
    >
      🎨 قيد العمل
    </button>
  )}

  {/* زر مكتمل */}
  {order.status === "قيد العمل" && (
    <button
      style={{
        padding: "8px 16px",
        backgroundColor: "#388e3c",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
      }}
     onClick={async () => {
  const canProceed = await ensureComparisonBoardsUploaded(order.linkedOrderId);
  if (!canProceed) return;

  setSelectedOrderId(order.id);
  setSelectedLinkedOrderId(order.linkedOrderId);
  setSelectedRequestKind(order.requestKind || "new"); // ✅ مهم
  setDrawingChecklist({ percentage: false, matchPrint: false, notes: false, colors: false });
  setCompleteOpen(true);
}}

    >
      ✅ مكتمل
    </button>
  )}
</Box>

            </AccordionDetails>
          </Accordion>
        ))
      )}

{/* ✅ هنا نضيف البوب أب الجديد */}
<Dialog open={completeOpen} onClose={() => setCompleteOpen(false)}>
  <DialogTitle>📤 رفع فيديوهات الرسم</DialogTitle>
  <DialogContent>
    <Box sx={{ mb: 1 }}>
      <Typography sx={{ fontWeight: "bold", mb: 1 }}>
        ✅ نقاط الفحص (إلزامية):
      </Typography>
      {DRAWING_CHECKLIST_ITEMS.map((item) => (
        <FormControlLabel
          key={item.key}
          sx={{ display: "flex" }}
          control={
            <Checkbox
              checked={drawingChecklist[item.key]}
              onChange={(e) =>
                setDrawingChecklist((prev) => ({
                  ...prev,
                  [item.key]: e.target.checked,
                }))
              }
            />
          }
          label={item.label}
        />
      ))}
    </Box>

    <Button variant="outlined" component="label" sx={{ mt: 2 }}>
      اختر فيديوهات من جهازك
      <input
        hidden
        type="file"
        accept="video/*"
        multiple  // ✅ يسمح برفع أكثر من فيديو
        onChange={(e) => {
          const files = Array.from(e.target.files || []);
          const nonVideoFile = files.find((f) => !f.type.startsWith("video/"));

          if (nonVideoFile) {
            alert("⚠️ مسموح فقط برفع فيديوهات الرسم، لا يمكن رفع صور.");
            e.target.value = "";
            return;
          }

          setSelectedVideo((prev) => [...(prev || []), ...files]); // نخزنها كمصفوفة (تنضاف للمختارة)
          e.target.value = "";
        }}
      />
    </Button>

    {selectedVideo?.length > 0 && (
      <Box sx={{ mt: 1 }}>
        <Typography sx={{ fontWeight: "bold" }}>🎥 الملفات المختارة:</Typography>
        <UploadPreview files={selectedVideo} onChange={setSelectedVideo} />
      </Box>
    )}

    {loading && (
      <Box sx={{ mt: 2, textAlign: "center" }}>
        <CircularProgress />
        <Typography>جاري رفع الفيديو...</Typography>
      </Box>
    )}
  </DialogContent>

  <DialogActions>
    <Button
      onClick={() => {
        setCompleteOpen(false);
        setDrawingChecklist({ percentage: false, matchPrint: false, notes: false, colors: false });
      }}
    >
      إلغاء
    </Button>
    <Button
      variant="contained"
      color="success"
      disabled={uploading}
      onClick={async () => {
        if (!selectedVideo?.length) {
          alert("يرجى اختيار فيديو واحد على الأقل قبل الحفظ");
          return;
        }

        const missingChecklistItem = DRAWING_CHECKLIST_ITEMS.find(
          (item) => !drawingChecklist[item.key]
        );
        if (missingChecklistItem) {
          alert(`⚠️ يجب تأكيد كل نقاط الفحص قبل المتابعة (${missingChecklistItem.label})`);
          return;
        }

        try {
          setUploading(true);

          // ✅ نرفع كل الفيديوهات دفعة واحدة
          const videoUrls = [];
          for (const video of selectedVideo) {
            const videoRef = ref(storage, `videos/${Date.now()}-${video.name}`);
            await uploadBytes(videoRef, video);
            const url = await getDownloadURL(videoRef);
            videoUrls.push(url);
          }

          // ✅ تحديث كولكشن حليمة
          const halimaRef = doc(db, "halimaRequests", selectedOrderId);
          await updateDoc(halimaRef, {
            status: "مكتمل",
            videoLinks: videoUrls, // نخزن كمصفوفة بدل link واحد
            drawingChecklist,
          });

          // ✅ نحذف الطلب من الواجهة
          setOrders((prevOrders) =>
            prevOrders.filter((o) => o.id !== selectedOrderId)
          );

          // ✅ تحديث الطلب الأصلي
          const orderRef = doc(db, "orders", selectedLinkedOrderId);
          const originalSnap = await getDocs(collection(db, "orders"));
          const originalDoc = originalSnap.docs.find(
            (d) => d.id === selectedLinkedOrderId
          );
          const oldHistory = originalDoc?.data()?.history || [];

   // ✅ نحدد نوع الطلب من الـ halimaRequests نفسه
const isDirect = selectedRequestKind === "direct";

// ✅ حتى بالبيع المباشر لازم نخليها "رسم حليمة مكتمل" حتى الورشة يكمّل تغليف
const finalStatus = "عند برهان - رسم حليمة مكتمل";

await updateDoc(orderRef, {
  status: finalStatus,
  drawingCompleted: true,
  drawingSent: true,
  isDirectSale: isDirect,          // ✅ تثبيت البيع المباشر على الطلب الأصلي
  videoLinks: videoUrls,
  drawingChecklist,
  history: [
    ...oldHistory,
    {
      status: finalStatus,
      by: "حليمة",
      timestamp: new Date(),
      changes: `✅ اكتمل الرسم + تم رفع ${videoUrls.length} فيديو`,
    },
  ],
});



          setSnackbarMsg("✅ تم رفع جميع الفيديوهات بنجاح!");
          setSnackbarOpen(true);
          setCompleteOpen(false);
          setSelectedVideo([]);
          setDrawingChecklist({ percentage: false, matchPrint: false, notes: false, colors: false });
        } catch (error) {
          console.error("❌ خطأ في رفع الفيديوهات:", error);
          alert("❌ حدث خطأ أثناء رفع الفيديوهات");
        } finally {
          setUploading(false);
        }
      }}
    >
      {uploading ? (
        <>
          <CircularProgress size={20} sx={{ color: "white", mr: 1 }} />
          جاري الرفع...
        </>
      ) : (
        "📤 رفع وحفظ الكل"
      )}
    </Button>
  </DialogActions>
</Dialog>


   <Snackbar
  open={snackbarOpen}
  autoHideDuration={4000}
  onClose={() => setSnackbarOpen(false)}
  anchorOrigin={{ vertical: "top", horizontal: "center" }}
>
  <Alert severity="success" variant="filled">
    {snackbarMsg}
  </Alert>
</Snackbar>

    </Container>
  );
};

export default HalimaDashboard;
